import {useState} from "react";
import { Modal, Button } from "react-bootstrap";

import {TenantFrontendApi_PostSendEmailByEmail} from './TenantFrontendApi'

import { Translate } from "./Translator"
import Header from "./Header"
import Footer from "./Footer"
import BlueBar from "./BlueBar";

import './Tenant.css';
import './EditUser.css';

function LostPassword(){

    const [mRepaint,SetRepaint]=useState(false)
    const [mUserEmailAddress,SetUserEmailAddress] = useState("")
    const [mSendInviteResult, SetSendInviteResult] = useState("")
    const [redirectAfterClose, setRedirectAfterClose] = useState(false);
    
    function languageChanged(){
        SetRepaint(!mRepaint)
    }

    function SendInviteButton()
    {
        if (!ValidateEmail(mUserEmailAddress)) {
            SetSendInviteResult("Invalid email address. Please enter a valid format.")
        }

        else{
            SendInviteEmail()
            SetSendInviteResult("We've sent password reset instructions to the email address you provided.")
            setRedirectAfterClose(true);
        }

    }

    const ValidateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    async function SendInviteEmail()
    {
        try
        {
            console.log("UserEmailAddress: " + mUserEmailAddress)
            const SendMessageResponse = await TenantFrontendApi_PostSendEmailByEmail(mUserEmailAddress)
            console.log(SendMessageResponse)
            SetUserEmailAddress("")
        }

        catch(ex){
            console.log(ex.response.data)
            var error = ex;
            try { error = ex.response.data.Exception; } catch {}  
            console.log("Error: " + error);
        }
    }

    const INVALID_REDIRECT_PATHS = [
        "/lostpassword",
        "/resetpassword"
    ];

    const redirectToLogin = () => {
        const currentUrl = new URL(window.location.href);
        const path = currentUrl.pathname;

        const safeRedirect =
            INVALID_REDIRECT_PATHS.includes(path)
                ? "https://userportal.cloudcti.nl/"
                : currentUrl.href;

        const redirectUrl = encodeURIComponent(safeRedirect);

        window.location.href =
            "https://signin-va.cloudcti.nl/signin/onelogin" +
            "?clientid=userportal&redirecturl=" + redirectUrl;
    };


    return(      
            <span>

                <Header onLanguageChanged={() => languageChanged()}/>

                <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>

                    <tr className="pagetop3">
                        <td height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </table>

                <table width="1200" cellPadding={0} cellSpacing={0} align="center" >
                    <tbody>                

                        <tr className="pagetop4">
                            <td colSpan={4} height="75" valign="left" className="activetenants width30">
                                {Translate("Lost. Did you lose something?")}
                            </td>
                        </tr>

                        <tr className="pagetop4">
                            <td colSpan={4} className="horizontalLine width30" >
                                <BlueBar/>
                            </td>
                        </tr>

                        <tr height="50"/>                
                    </tbody>
            </table>

            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>

                <tr height="20" ></tr>

                <tr>
                    <td width="40"></td>
                    <td>
                        {Translate("If you’re having trouble signing in, you can request a password reset link. Please note that this option only works if you sign in with a valid email address and authenticate using your CloudCTI credentials. If you sign in using credentials from your telephony platform, please test your login there and reset your password on that platform if necessary.")}
                    </td>
                </tr>
                
                <tr height="20"/>
                
                <tr>
                    <td width="40"></td>
                    <td>
                        {Translate("Please enter your email, and we will send you a reset password link")}
                    </td>
                </tr>
                
                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">{Translate("Email")} <span className="red"> *</span></td>
                </tr>
                   
                <tr height="10"/>

                <tr height="40">
                    <td width="40"></td>
                    <td><input type="email" value={mUserEmailAddress} onChange={e=>SetUserEmailAddress(e.target.value)} className="inputtd"></input>
                    </td>
                    <td></td>
                </tr>

                <tr height="20"/>

                <tr>
                    <td width="40"></td>
                    <td className="bold fontsizesmall">
                        <button
                            disabled={!(typeof mUserEmailAddress === "string" && mUserEmailAddress.trim())}
                            className="saveusersettingsbutton bold"
                            onClick={SendInviteButton}
                        >
                            {Translate("Send")}
                        </button>
                    </td>
                </tr>
                
                <tr height="40"/>

                </tbody>
            </table>

            {/*FreeSpace*/}
            <table>
                <tbody>
                    <tr height="160"></tr>
                </tbody>
            </table>

            {/*footerTable*/}
            <table>
                <tbody>
                    <tr height="90"></tr>
                </tbody>
            </table>

            <Footer/>

            {/* Animation part */}
            <Modal animation={false} style={{ opacity: 1 }} show={mSendInviteResult !== ""} onHide={() => SetSendInviteResult("")} centered>
                
                <Modal.Body style={{ textAlign: "center" }}>
                    {Translate(mSendInviteResult)}
                </Modal.Body>
                
                <Modal.Footer style={{ justifyContent: "center" }}>
                    
                    {
                        <Button variant="dark" onClick={() => { SetSendInviteResult(""); if (redirectAfterClose) redirectToLogin();}}>
                            {Translate("Ok")}
                        </Button>
                    }
                </Modal.Footer>
            </Modal>

        </span>
        )
}

export default LostPassword